import useDocumentTitle from "./hooks/use-document-title";

// lives inside the Router like <LocationTracking /> so the title updates on navigation
export default function DocumentTitle({ debug }: { debug?: boolean }) {
	useDocumentTitle(debug);

	return null;
}
